import { ServiceProvider } from '@wix/thunderbolt-symbols'

export const removeDuplicatesServices = (services: Array<ServiceProvider>): Array<ServiceProvider> => {
	return [...new Map(services.map((item: ServiceProvider) => [item.definition, item])).values()]
}

export const getServiceConfigs = (registeredServices: Array<ServiceProvider>): Record<string, any> => {
	return registeredServices.reduce((acc: Record<string, any>, service: ServiceProvider) => {
		if (service.hasNonSerializablePlatformConfig || service.platformConfig) {
			acc[service.definition] = service.hasNonSerializablePlatformConfig ? {} : service.platformConfig
		}
		return acc
	}, {})
}
